// Contains event to the confines of the component (preventing propagation and default behavior)
const wrapEventHandler = eventHandler => {
  if (!eventHandler) {
    return null;
  }
  return e => {
    e.stopPropagation();
    e.preventDefault();
    return eventHandler(e);
  };
};

export { wrapEventHandler };
